import { create } from "zustand";

interface AuthenticationState {
    showCalendar: boolean;
    setShowCalendar: (showCalendar: boolean) => void;
}

export const useHotelDetailAction = create<AuthenticationState>()(
    (set) => ({
        showCalendar: false,
        setShowCalendar: (showCalendar) => set({ showCalendar }),
    }),
);

